import {List, fromJS} from 'immutable'

import {
  SHOW_MODAL,
  CLOSE_MODAL,
  CLOSE_ALL_MODALS
} from '../action_types'

import createTimestampKey from '../helpers/create_timestamp_key'

export default (state = List(), action) => {
  switch (action.type) {
    case SHOW_MODAL:
      if (action.modal.identifier) {
        const modalKey = createTimestampKey([action.modal.type], action.modal.identifier)
        const modal = fromJS(action.modal).mergeDeep({props: {modalKey}})

        const index = state.findKey((modal) => modal.getIn(['props', 'modalKey']) === modalKey)

        if (typeof index === 'undefined') return state.unshift(modal)

        return state.set(index, modal)
      }
      else {
        const modalKey = createTimestampKey([action.modal.type])
        const modal = fromJS(action.modal).mergeDeep({props: {modalKey}})

        return state.unshift(modal)
      }

    case CLOSE_MODAL:
      return state
        .filterNot((modal) => modal.getIn(['props', 'modalKey']) === action.modalKey)

    case CLOSE_ALL_MODALS:
      return List()

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/reducers/modals.js
 **/